function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface6452684"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.039216%,80%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 126.023438 64 C 126.023438 29.75 98.25 1.976562 64 1.976562 C 29.75 1.976562 1.976562 29.75 1.976562 64 C 1.976562 98.25 29.75 126.023438 64 126.023438 C 98.25 126.023438 126.023438 98.25 126.023438 64 Z M 126.023438 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.148438 43.226562 C 96.699219 39.449219 93.726562 40.050781 90.5 40.699219 C 88.574219 41.101562 80 43.601562 66.476562 57.898438 C 60.851562 63.824219 57.148438 68.550781 54.699219 72.148438 C 53.199219 70.324219 51.5 68.351562 49.699219 66.574219 C 44.175781 61.050781 38 57.25 37.75 57.101562 C 35.175781 55.523438 31.800781 56.324219 30.199219 58.925781 C 28.625 61.5 29.425781 64.875 32 66.476562 C 32.050781 66.5 37.351562 69.773438 41.898438 74.351562 C 46.550781 79 50.773438 85.300781 50.824219 85.375 C 51.851562 86.925781 53.574219 87.824219 55.398438 87.824219 C 55.699219 87.824219 56.023438 87.800781 56.351562 87.75 C 58.5 87.375 60.199219 85.773438 60.726562 83.675781 C 60.75 83.625 62.925781 77.601562 74.398438 65.5 C 83.648438 55.726562 89.824219 52.625 91.976562 51.773438 C 92 51.773438 92 51.773438 92.050781 51.773438 C 92.050781 51.773438 92.125 51.75 92.25 51.675781 C 92.625 51.523438 92.824219 51.476562 92.824219 51.476562 C 92.726562 51.5 92.675781 51.5 92.675781 51.5 L 92.675781 51.476562 C 93.675781 51.050781 95.523438 50.25 95.550781 50.226562 C 98.324219 49.023438 99.25 46.023438 98.148438 43.226562 Z M 98.148438 43.226562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.f3d5f007c6caef6100075ed015c246b4.svg";
export { ForwardRef as ReactComponent };